export class Contactenos {
    _id_contactenos: Number;
    rut: String;
    nombre: String;
    telefono: String;
    email: String;
    numero_cliente: String;    
    consulta: Boolean;
    reclamo: Boolean;
    sugerencia: Boolean;
    felicitacion: Boolean;
    proceso: String;
    subproceso: any;
    detalle: String;
    archivo_contactenos: String;    
    acepto_condiciones: Boolean;
    acepto_newsletters: Boolean;
    acepto_privacidad: Boolean;
    acepto_suscripcion: Boolean;
    grupo_codigo: String;
    codigo: String;
    token: String;
    marca: String;
    ip: string;
    // Nuevos campos Decreto N�79
    medioEnvioRespuesta: String; // k) Medio de contacto elegido
    direccionPostal: String; // c) Direcci�n postal - Calle   
    esReclamoPorCobro: Boolean; // Indicador de reclamo por cobro
    montoReclamado: Number; // h) Monto reclamado
    conceptoCobro: String; // h) Concepto reclamado
    otroConceptoCobro: String; // Especificaci�n cuando conceptoCobro = "Otros"
    documentosAdjuntos: Array<{Item: String}>; // Documentos adjuntos con detalle
}

// Interface para DocumentoAdjunto interno del componente
export interface DocumentoAdjunto {
    detalle: string;
    fileName: string;
    fileData: string;
    infoMessage: boolean;
    errorInfoMessage: string;
}
